import { useContext } from 'react'
import { AIContext } from '../ChatContextProvider'

/**
 * Hook to access the AI chat context from any component within the AIProvider.
 * Provides access to all chat functionality including messages, sending, and edit handling.
 * 
 * @throws Error if used outside of an AIProvider
 */
export function useAIChat() {
  const context = useContext(AIContext)
  if (!context) {
    throw new Error('useAIChat must be used within an AIProvider')
  }
  return context
}